module.exports = __webpack_public_path__ + "assets/images/success-dark_f9f842c32268dec44068bdc37f0d652f.jpg";